import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled(Group)`
  min-width: 50%;
  height: 100%;

  ${mediaQueryUp.tablet} {
    min-width: unset;
    height: unset;
  }
`

function StatisticTrustIndicator() {
  const intl = useIntl()

  return (
    <Container direction="vertical-reverse" horizontalAlign="center" verticalAlign="center" gap={4}>
      <Heading variant="heading3" align="center">{intl.formatMessage({
        id: 'z2GlBhmuDh3wEzN80GY5',
        defaultMessage: '14 million members',
      })}
      </Heading>
      <BodyText colour="light-foreground-alt" variant="medium" align="center">{intl.formatMessage({
        id: 'qpYdWgtdmj15PjY6xyKD',
        defaultMessage: 'Trusted by',
      })}
      </BodyText>
    </Container>
  )
}

export default StatisticTrustIndicator
